import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import api from '../../services/api';
import { useAuth } from '../../context/AuthContext';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match!');
      return;
    }
    if (password.length < 6) {
      setError('Password must be at least 6 characters!');
      return;
    }

    setLoading(true);
    try {
      await api.post(`/auth/reset-password/${token}`, { password });
      logout(); // clear any existing session so /login actually shows the form
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'This reset link is invalid or has expired.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>🍳 GrubClub</h1>
        <h2 style={styles.subtitle}>Set a new password</h2>

        {success ? (
          <p style={styles.text}>✅ Password reset! Redirecting you to login...</p>
        ) : (
          <>
            {error && <div style={styles.error}>{error}</div>}
            <form onSubmit={handleSubmit}>
              <div style={styles.inputGroup}>
                <label style={styles.label}>New Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={styles.input}
                  placeholder="At least 6 characters"
                  required
                />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Confirm Password</label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  style={styles.input}
                  placeholder="Re-enter your new password"
                  required
                />
              </div>
              <button type="submit" style={loading ? styles.buttonDisabled : styles.button} disabled={loading}>
                {loading ? 'Saving...' : 'Reset Password'}
              </button>
            </form>
            <p style={styles.switchText}>
              <Link to="/login" style={styles.link}>Back to login</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5' },
  card: { backgroundColor: 'white', padding: '40px', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', width: '100%', maxWidth: '400px' },
  title: { textAlign: 'center', color: '#e67e22', marginBottom: '8px', fontSize: '32px' },
  subtitle: { textAlign: 'center', color: '#333', marginBottom: '24px', fontSize: '20px' },
  text: { color: '#555', lineHeight: 1.5, textAlign: 'center' },
  error: { backgroundColor: '#ffe0e0', color: '#c0392b', padding: '10px', borderRadius: '8px', marginBottom: '16px', textAlign: 'center' },
  inputGroup: { marginBottom: '16px' },
  label: { display: 'block', marginBottom: '6px', color: '#555', fontWeight: '600' },
  input: { width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '16px', boxSizing: 'border-box', outline: 'none' },
  button: { width: '100%', padding: '12px', backgroundColor: '#e67e22', color: 'white', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: '600', cursor: 'pointer', marginTop: '8px' },
  buttonDisabled: { width: '100%', padding: '12px', backgroundColor: '#ccc', color: 'white', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: '600', cursor: 'not-allowed', marginTop: '8px' },
  switchText: { textAlign: 'center', marginTop: '20px', color: '#666' },
  link: { color: '#e67e22', textDecoration: 'none', fontWeight: '600' },
};

export default ResetPassword;
